import { render, staticRenderFns } from "./MitNoAccessPage.vue?vue&type=template&id=026f60be&scoped=true"
import script from "./MitNoAccessPage.vue?vue&type=script&lang=js"
export * from "./MitNoAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026f60be",
  null
  
)

export default component.exports